var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubmitted = function SvgSubmitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.838 74.465c18.115 0 32.8-14.686 32.8-32.8 0-18.115-14.685-32.8-32.8-32.8-18.115 0-32.8 14.685-32.8 32.8 0 18.114 14.685 32.8 32.8 32.8Z",
    fill: "#2F5EA7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.598,
    cy: 38.487,
    r: 32.779,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.262 46.708 7.611-9.096-.694-5.653-4.718 5.255-3.931 8.39a1.036 1.036 0 0 0 1.732 1.104Z",
    fill: "#132643"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m45.46 37.214 13.702 7.026a2.072 2.072 0 0 0 2.932-1.255L72.751 7.049A1.036 1.036 0 0 0 71.38 5.79L24.732 24.07a2.072 2.072 0 0 0-.104 3.814l11.954 5.45 5.73 13.825 3.149-9.945Z",
    fill: "#2F5EA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.582 33.333 66.24 11.225 45.46 37.214l-2.144 9.165a1.036 1.036 0 0 1-1.983.116l-4.751-13.162Z",
    fill: "#1C3864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.87 41.838S16.549 49.48 2.4 46.682M33.073 49.132s-8.698 5.767-14.238 6.81M41.252 53.478s-2.466 2.465-4.93 4.312",
    stroke: "#2F5EA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgSubmitted;